module.exports = __webpack_public_path__ + "static/STG20_Mobile_960_Module2_YellowSpritz-e8c0de754dade9e7c13ac108a182812f.jpg";